<template>
  <div class="text-center">
    <v-dialog v-model="PurchaseProducts.showing" max-width="850px">
      <v-card outlined>
        <v-toolbar color="transparent" elevation="0" class="ma-2">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="search"
            single-line
            hide-details
            reguler
            clearable
            outlined
          ></v-text-field>
        </v-toolbar>
      </v-card>
      <v-card>
        <v-card-text>
          <!-- change display just the first item of the datatable items -->
          <v-data-table
            v-if="
              PurchaseProducts.selected_product &&
              PurchaseProducts.selected_product.length
            "
            :headers="headers"
            :items="[PurchaseProducts.selected_product[0]]"
            class="elevation-1"
            hide-default-footer
            :search="search"
            :items-per-page="PurchaseProducts.selected_product.length"
          >
            <template v-slot:loading>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="caption">
                    please wait loading...
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title> No conversations </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template v-slot:no-results>
              <v-alert
                :value="true"
                outlined
                text
                color="error"
                icon="mdi-alert"
                class="mt-4 text--center"
                >{{ `no results with '${search}'` }}</v-alert
              >
            </template>
            <template v-slot:item="{ item }">
              <tr>
                <td class="text-center">
                  <a
                    :href="item.url || ''"
                    class="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent"
                    target="_blank"
                    >{{ item.url || "-" }}
                  </a>
                </td>
                <td class="text-center">
                  {{ item.date || "-" }}
                </td>
              </tr>
            </template>
          </v-data-table>
          <v-row justify="center" align="center" v-else>
            <v-col cols="auto">
              <strong
                >No "{{ this.$t("messanger.dash.table_head.product") }}"</strong
              >
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="blue darken-1"
            text
            @click="PurchaseProducts.showing = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "PurchaseProducts",
  data: () => {
    return {
      search: "",
      headers: [
        {
          text: "URL",
          value: "url",
          filterable: true,
          sortable: false,
          align: "center",
        },
        {
          text: "Date",
          value: "date",
          filterable: true,
          sortable: true,
          align: "center",
        },
      ],
    };
  },
  computed: {
    PurchaseProducts() {
      return this.$store.state.PurchaseProducts;
    },
  },
};
</script>
